import { createAsyncThunk } from "@reduxjs/toolkit";
import  ManagementCostService from "../../services/managementcost.servics"



export const EditManagementCost = createAsyncThunk(
    "/post/editmanagementcost",
    async (item,thunkAPI) => {
        try {
            const data = await ManagementCostService.EditManagementCost(item);
            return data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue({ message });
        }
    }
);

export const UpdateManagementCost = createAsyncThunk(
    "/post/updatemanagementcost",
    async (item,thunkAPI) => {
        try {
            const data = await ManagementCostService.UpdateManagementCost(item);
            return data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue({ message });
        }
    }
);

export const EditComapnyDucuments = createAsyncThunk(
    "/post/editcomapnyducuments",
    async (item,thunkAPI) => {
        try {
            const data = await ManagementCostService.EditComapnyDucuments(item);
            return data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue({ message });
        }
    }
);

export const UpdateComapnyDucuments = createAsyncThunk(
    "/post/updatecomapnyducuments",
    async (item,thunkAPI) => {
        try {
            const data = await ManagementCostService.UpdateComapnyDucuments(item);
            return data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue({ message });
        }
    }
);

export const AddManagementCosts = createAsyncThunk(
    "/post/addmanagementcost",
    async (item, thunkAPI) => {
        try {
            const data = await ManagementCostService.AddManagementCost(item);
            return data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue({ message });
        }
    }
);

export const ListManagementCost = createAsyncThunk(
    "/post/listmanagementcost",
    async (item, thunkAPI) => {
        try {
            const data = await ManagementCostService.ListManagementCost(item);
            return data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue({ message });
        }
    }
);

export const UpdateManagementCostMC = createAsyncThunk(
    "/post/updatemanagementcostmc",
    async (item, thunkAPI) => {
        try {
            const data = await ManagementCostService.UpdateManagementCostMC(item);
            return data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue({ message });
        }
    }
);

export const AddManagementCostHead = createAsyncThunk(
    "/post/addmanagementcosthead",
    async (item,thunkAPI) => {
        try {
            const data = await ManagementCostService.AddManagementCostHead(item);
            return data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue({ message });
        }
    }
);

export const ListManagementCostHead = createAsyncThunk(
    "/post/listmanagementcosthead",
    async (item,thunkAPI) => {
        try {
            const data = await ManagementCostService.ListManagementCostHead(item);
            return data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue({ message });
        }
    }
);

export const GetManagementCostHeadDetail = createAsyncThunk(
    "/post/getmanagementcostheaddetail",
    async (item,thunkAPI) => {
        try {
            const data = await ManagementCostService.GetManagementCostHeadDetail(item);
            return data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue({ message });
        }
    }
);

export const GetManagementCostDetail = createAsyncThunk(
    "/post/getmanagementcostdetail",
    async (item, thunkAPI) => {
        try {
            const data = await ManagementCostService.GetManagementCostDetail(item);
            return data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue({ message });
        }
    }
);

export const UpdateManagementCostHead = createAsyncThunk(
    "/post/updatemanagementcosthead",
    async (item,thunkAPI) => {
        try {
            const data = await ManagementCostService.UpdateManagementCostHead(item);
            return data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue({ message });
        }
    }
);

export const DeleteManagementCostHead = createAsyncThunk(
    "/post/deletemanagementcosthead",
    async (item,thunkAPI) => {
        try {
            const data = await ManagementCostService.DeleteManagementCostHead(item);
            return data;
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue({ message });
        }
    }
);
